import Modal from '@common/vanilla_ui/general/modal';
import RcbForm from './rcbForm';
import rcbTrackings from './trackings';

const MODAL_ID = 'midfunnel-rcb-blocker-modal';

const showMidfunnelRCB = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams?.get('show_rcb') === 'true';

  if (paramValue) {
    new RcbForm('midfunnel-rcb-form', MODAL_ID);
    Modal.open(MODAL_ID, true);
    rcbTrackings.formStatusTracking('modal_open');
  }
};

export default {
  initialize: showMidfunnelRCB,
};
